import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

export const serviceComputed = {
	...mapState('taskManagementStore', Object.keys(state)),
	...mapGetters('taskManagementStore', Object.keys(getters))
};
export const serviceMethods = {
	...mapActions('taskManagementStore', Object.keys(actions)),
	...mapMutations('taskManagementStore', Object.keys(mutations))
};
